import React, {useEffect} from 'react';
import { Link } from 'react-router-dom'
import $ from "jquery";

var onresize = function(e) {
  //note i need to pass the event as an argument to the function
  const width = e.target.outerWidth;

  if(width < 650) {
    if($ && $(".sidebar"))
      $(".sidebar").addClass("toggled");
  }
}
window.addEventListener("resize", onresize);


const Nav = () => {
  
  useEffect(() => {
    
    // Toggle the side navigation
    $("#sidebarToggle, #sidebarToggleTop").on('click', function(e) {
      $("body").toggleClass("sidebar-toggled");
      $(".sidebar").toggleClass("toggled");
      if ($(".sidebar").hasClass("toggled")) {
        $('.sidebar .collapse').toggle();
      };
    });

    if(window.outerWidth < 650) {
      if($ && $(".sidebar"))
        $(".sidebar").addClass("toggled");
    }

    
  },[])
  
 return( <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

  <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
    <div className="sidebar-brand-text mx-1">My Site</div>
  </Link>

  <hr className="sidebar-divider my-0" />

  <li className="nav-item">
    <Link className="nav-link" to="/">
      <i className="fas fa-fw fa-tachometer-alt"></i>
      <span>Dashboard</span></Link>
  </li>

  <hr className="sidebar-divider my-0" />

 <li className="nav-item">
    <Link className="nav-link" to="/techSkills">
      <i className="fas fa-fw fa-cogs"></i>
      <span>Tech Skills</span></Link>
  </li>

  <hr className="sidebar-divider my-0" />

 <li className="nav-item">
    <Link className="nav-link" to="/experience">
      <i className="fas fa-fw fa-suitcase"></i>
      <span>Experience</span></Link>
  </li>


  <hr className="sidebar-divider my-0" />

 <li className="nav-item">
    <Link className="nav-link" to="/education">
      <i className="fas fa-fw fa-graduation-cap"></i>
      <span>Education</span></Link>
  </li>

  <hr className="sidebar-divider my-0" />

  <li className="nav-item">
     <Link className="nav-link" to="projects">
       <i className="fas fa-fw fa-code"></i>
       <span>Projects</span></Link>
   </li>

   
   <hr className="sidebar-divider my-0" />

   <li className="nav-item">
   <Link className="nav-link" to="/aboutMe">
        <i className="fas fa-fw fa-user"></i>
        <span>About Me</span></Link>
    </li>

    <hr className="sidebar-divider my-0" />

   <li className="nav-item">
    <Link className="nav-link" to="/contact">
        <i className="fas fa-fw fa-phone"></i>
        <span>Contact</span></Link>
    </li>
  
  

  <hr className="sidebar-divider d-none d-md-block" />

  <div className="text-center d-none d-md-inline">
    <button className="rounded-circle border-0" id="sidebarToggle"></button>
  </div>

</ul>)
}
export default Nav;